import Vue from 'vue'
import VueResource from 'vue-resource'
import Auth from '@/components/Auth'
import MyImage from '@/components/MyImage';
import { wxPlugin } from '@/utils/weixin'
import wxUtils from '@/utils/weixin/utils'

import App from './App.vue'
import router from './router'
import './mixins/index'
import './mixins/weixin'
import _global from '@/components/Global'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer,{
  defaultOptions:  { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": false, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": true, "fullscreen": true, "keyboard": false }
})
Viewer.setDefaults({
  zIndexInline: 2017
})
Vue.use(VueResource)

Vue.prototype.GLOBAL = _global
Vue.use(Auth)
Vue.use(wxPlugin, {
  someOption: true
})

Vue.config.productionTip = false

Vue.component('my-image', MyImage)
wxUtils.setWXConfig(window.location.href.split('#')[0], ['updateAppMessageShareData', 'updateTimelineShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'onMenuShareAppMessage', 'onMenuShareTimeline'])

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
